module.exports = __webpack_public_path__ + "static/media/heroimage_igib-027.ff77eaae.jpg";